import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip';
import { addContact } from 'actions/ringCentral';
import clsx from 'clsx';
import { useChatContext } from 'features/message-center/providers';
import { Permissions, userHasPermission } from 'services/Authorization';
import strings from 'strings';
import { SvgEmailFilled, SvgMessageFilled, SvgPhoneFilled } from 'UI/res/icons/filled';

import { useResumeCardStyles } from './ResumeCard.styled';

export const ResumeCardActions = React.memo(({ candidateId, phone, email }) => {
  const classes = useResumeCardStyles();
  const dispatch = useDispatch();
  const { openDrawer } = useChatContext();
  const canUseTextel = userHasPermission(Permissions.Textel.CanUseModule);

  const handlePhoneClick = useCallback(() => {
    if (!phone || !candidateId) return;
    dispatch(
      addContact({
        id: candidateId,
        role: 'candidate',
        phone,
        createdAt: new Date()
      })
    );
  }, [dispatch, phone, candidateId]);

  const handleTextClick = useCallback(() => {
    if (!canUseTextel || !phone || !candidateId) return;
    openDrawer({
      recipient: {
        entityId: candidateId,
        entityType: 'candidate',
        phone
      }
    });
  }, [canUseTextel, phone, candidateId, openDrawer]);

  return (
    <>
      <div className={clsx(!phone && classes.disabledAction)}>
        <Tooltip title={strings.shared.rowActions.actions.call} placement="bottom" arrow>
          <Link
            href={phone ? `tel:${phone}` : undefined}
            onClick={handlePhoneClick}
            className={classes.actionButton}
          >
            <SvgPhoneFilled className={classes.actionIcon} />
          </Link>
        </Tooltip>
      </div>
      <div className={clsx(!phone && classes.disabledAction)}>
        <Tooltip title={strings.shared.rowActions.actions.text} placement="bottom" arrow>
          {canUseTextel ? (
            <IconButton onClick={handleTextClick} className={classes.actionButton}>
              <SvgMessageFilled className={classes.actionIcon} />
            </IconButton>
          ) : (
            <Link
              href={phone ? `sms:${phone}` : undefined}
              onClick={handlePhoneClick}
              className={classes.actionButton}
            >
              <SvgMessageFilled className={classes.actionIcon} />
            </Link>
          )}
        </Tooltip>
      </div>
      <div className={clsx(!email && classes.disabledAction)}>
        <Tooltip title={strings.shared.rowActions.actions.email} placement="bottom" arrow>
          <Link
            href={email ? `mailto:${email}` : undefined}
            className={classes.actionButton}
            target="_blank"
            rel="noopener noreferrer"
          >
            <SvgEmailFilled className={classes.actionIcon} />
          </Link>
        </Tooltip>
      </div>
    </>
  );
});
